import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Plus,
  Building2,
  Home,
  FileText,
  DollarSign,
  Users,
  Receipt,
  Megaphone,
} from "lucide-react";
import { AddPropertyDialog } from "@/components/properties/AddPropertyDialog";
import { ContractWizardDrawer } from "@/components/contracts/wizard-v2";
import { AddPaymentDialog, AddExpenseDialog } from "@/components/finance";
import { AddAdWizardDialog } from "@/components/ads/wizard/AddAdWizardDialog";

export function QuickAddMenu() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [showPropertyDialog, setShowPropertyDialog] = useState(false);
  const [showContractDialog, setShowContractDialog] = useState(false);
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [showExpenseDialog, setShowExpenseDialog] = useState(false);
  const [showAdDialog, setShowAdDialog] = useState(false);

  const quickAddItems = [
    {
      labelAr: "عقار جديد",
      labelEn: "New Property",
      icon: Building2,
      action: () => setShowPropertyDialog(true),
    },
    {
      labelAr: "عقد جديد",
      labelEn: "New Contract",
      icon: FileText,
      action: () => setShowContractDialog(true),
    },
    {
      labelAr: "إعلان جديد",
      labelEn: "New Ad",
      icon: Megaphone,
      action: () => setShowAdDialog(true),
    },
    {
      labelAr: "تسجيل دفعة",
      labelEn: "Record Payment",
      icon: Receipt,
      action: () => setShowPaymentDialog(true),
    },
    {
      labelAr: "مصروف جديد",
      labelEn: "New Expense",
      icon: DollarSign,
      action: () => setShowExpenseDialog(true),
    },
  ];

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button className="gap-2">
            <Plus className="h-4 w-4" />
            <span className="hidden sm:inline">{t("إضافة سريعة", "Quick Add")}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56 bg-background z-50">
          <DropdownMenuLabel>{t("إضافة سريعة", "Quick Add")}</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {quickAddItems.map((item, index) => (
            <DropdownMenuItem
              key={index}
              onClick={item.action}
              className="cursor-pointer"
            >
              <item.icon className="h-4 w-4 me-2" />
              {t(item.labelAr, item.labelEn)}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Dialogs */}
      <AddPropertyDialog open={showPropertyDialog} onOpenChange={setShowPropertyDialog} />
      <ContractWizardDrawer open={showContractDialog} onOpenChange={setShowContractDialog} />
      <AddPaymentDialog open={showPaymentDialog} onOpenChange={setShowPaymentDialog} />
      <AddExpenseDialog open={showExpenseDialog} onOpenChange={setShowExpenseDialog} />
      <AddAdWizardDialog open={showAdDialog} onOpenChange={setShowAdDialog} />
    </>
  );
}
